'use strict'

export default {
  getIndexInCollection: function(propertyName, id, collection) {
    for (let i = 0; i < collection.length; i++) {
      var element = collection[i]

      if (element[propertyName] === id) {
        return i
      }
    }

    return -1
  },

  tryCallService: function() {
    let userId = window.sessionStorage.getItem('userId')
    if (userId !== null) {
      return userId
    }
    window.location = '/'
  },

  findGroup: function(groupId, collection) {
    for (let i = 0; i < collection.length; i++) {
      var element = collection[i]

      if (element.id === groupId) {
        return element
      }
    }

    return null
  },

  getCustomerTypeName: function(customerTypeId, customerTypes) {
    for (let i = 0; i < customerTypes.length; i++) {
      let element = customerTypes[i]

      if (element.id === customerTypeId) {
        return element.name
      }
    }
  },

  getLangName: function(languageId, languages) {
    var languageName = ''

    for (var i = 0; i < languages.length; i++) {
      if (languages[i].languageId === languageId) {
        languageName = languages[i].langName
        break
      }
    }

    return languageName
  },
  generatePin: function() {
    return new Array(6).join().replace(/(.|$)/g, function() {
      let initialValue = ((Math.random() * 36) | 0).toString(36)
      return initialValue[Math.random() < 0.5 ? 'toString' : 'toUpperCase']()
    })
  }
}
